export default "__VITE_ASSET__0eea43da__"